import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { setAuthToken} from "../../../modules/user";

class NormalTopMenu extends Component {
    constructor(props){
        super(props)
        this.state = {
            myProfileRedirect: false
        }
    }
    componentDidUpdate(){
        const {myProfileRedirect} = this.state;
        if(myProfileRedirect){
            this.setState({myProfileRedirect: false})
        }
    }
    render() {
        let { user } = this.props;
        const {myProfileRedirect} = this.state;
        let profileRoute = `/teamMember/${user.currentUserId}/`;
        return (
            <div className="flex-grow-1" key="exit-icon">
            <div
            className="mr-4 mt-3 pr-4 pointer float-right top-bar-button"
            onClick={() => {
                setAuthToken("");
                window.location = this.props.history.replace(""); // attempt to kill react router state
            }}
            >
            Log Out <i className="mt-3 text-secondary fa fa-sign-out" />
            </div>
            <div className="mr-4 mt-3 pr-4 pointer float-right top-bar-button" onClick={()=>this.setState({myProfileRedirect:true})}>
                {/* <Link to={profileRoute} onClick={()=> this.routerAssist()}> */}
                    <span>My Profile </span>
                    <i className="mt-3 text-secondary fa fa-user-md"></i>
                {/* </Link> */}
            </div>
            {myProfileRedirect && <Redirect to={profileRoute}></Redirect>}
        </div>
        );
    }
}

export default NormalTopMenu;




// WEBPACK FOOTER //
// ./src/components/containers/normal-top-menu/normal-top-menu.js